document.addEventListener("DOMContentLoaded", () => {

        new Menu();

        const dashboard      = document.getElementById('dashboard');
        const summary        = document.getElementById('summary');
        const dashboardRso   = document.getElementById('dashboard-rso');
        const bannerCookie   = document.getElementById('banner-cookie');
        const curvedSlide    = document.getElementById('curvedSlide');
        const notification   = document.getElementById('notification-fixed');
        const games          = document.getElementsByClassName('game')[0];
        const lottie         = document.getElementsByClassName('lottie')[0];
        const carousels      = document.querySelectorAll('.carousel');
        const accordions     = document.querySelectorAll('.accordion');
        const accordionsList = document.querySelectorAll('.accordion-list');
        const modals         = document.querySelectorAll('.open-modal');
        const asyncForm      = document.querySelectorAll('[action^="/async"]');
        const listChoice     = document.querySelectorAll('.list-choice');
        const selects        = document.querySelectorAll('.select');
        const selectsRadio   = document.querySelectorAll('.select-radio');
        const hits           = document.querySelectorAll('.hits');

        if (dashboard) new Dashboard();
        if (summary) new Summary();
        if (dashboardRso) new DashboardRso();
        if (games) new Game(games);
        if (bannerCookie) new Cookie();
        if (notification) new Notifications(notification);
        if (curvedSlide) CNOSF_APP.addModule('CurvedSlider', new CurvedSlider(curvedSlide));
        if (lottie) CNOSF_APP.addModule('lottie', new Lottie());

        for (let i = 0; i < hits.length; i++) {
            new Hits(hits[i]);
        }
        for (let i = 0; i < selects.length; i++) {
            new Select(selects[i]);
        }
        for (let i = 0; i < selectsRadio.length; i++) {
            new SelectRadio(selectsRadio[i]);
        }
        for (let i = 0; i < asyncForm.length; i++) {
            new AsyncForm(asyncForm[i]);
        }
        for (let i = 0; i < listChoice.length; i++) {
            ListChoice.toggleAllChoice(listChoice[i]);
        }
        for (let i = 0; i < carousels.length; i++) {
            new Carousel(carousels[i]);
        }
        for (let i = 0; i < accordions.length; i++) {
            new Accordion(accordions[i])
        }
        for (let i = 0; i < accordionsList.length; i++) {
            new AccordionList(accordionsList[i])
        }
        for (let i = 0; i < modals.length; i++) {
            new Modal(modals[i])
        }
    }
);

/**
 * C.N.O.S.F JS application
 */
class CNOSFApp {
    constructor() {
        this.modules = [];
    }

    addModule(moduleName, moduleInstance) {
        this.modules[moduleName] = moduleInstance;
    }

    getModule(moduleName) {
        return this.modules[moduleName] || null
    }
}

// Make instance global
const CNOSF_APP = new CNOSFApp();